//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import httpHelper from '../../src/common/helpers/HttpHelper';
import environments from '../../src/common/environments/environment';
const http = new httpHelper();

export const AdminDashboardActions = {
    //GetAdminDashboardJSON: getAdminDashboardJSON,
    GetAdminDashboardData: getAdminDashboardData,
    GetAdminCTALinks: getAdminCTALinks,
    GetUserDetails: getUserDetails,
    GetUserAccount: getUserAccount,
    getAdminDashboardCMSContent:getAdminDashboardCMSContent
}

//commented due to sitecore integration
// function getAdminDashboardJSON() {
//     return http.jsonGet(environments.CONTAINER_NAME + environments.ADMIN_DASHBOARD_JSON);
// }

function getAdminDashboardData() {
    let refAdminDashboard = environments.ADMIN_DASHBOARD_DATA;
    return http.adminGet(refAdminDashboard);
}

function getUserAccount() {
    let refAdminDashboard = environments.USER_ACCOUNT;
    return http.adminGet(refAdminDashboard);
}

function getUserDetails() {
    let refAdminDashboard = environments.USER_DETAILS
    return http.adminGet(refAdminDashboard);
}

function getAdminCTALinks(countryCode) {
    let refAdminDashboard = environments.ADMIN_DASHBOARD_CTA_LINKS + "?countryCode=" + countryCode
    return http.adminGet(refAdminDashboard);
}

function getAdminDashboardCMSContent(payload) {
    return http.CMSpost(environments.ADMIN_PAGE_DETAILS, payload);
}

